import React, { useState, useEffect } from 'react';
import { Entrycameramonitor } from '../../../../api/EntryCameraMonitorifl';
import { Col, Container, Row, Card, CardHeader, Input, Label, FormGroup, Button, Spinner } from 'reactstrap';
import FaceCard from './FaceCard';
import PaginationComponent from './Pagination';
import './faceDetections.css';
import { getCurrentcompleteDate } from '../../../../utils/getCurrentcompleteDate';
import FiltersComponent from "../../pages/components/Filters/FiltersComponent";
import { errorToast } from '../../../../_helper/helper';
import ImageZoomSingleImage from '../../../Dashboards/AreaDashbaord/reports/Components/LiveAlertsCards/ImageZoomSingleImage';




const LOCAL_STORAGE_KEY = 'detection_page';

const FaceDetections = () => {
  const getInitialFilters = () => {
    const savedFilters = localStorage.getItem(LOCAL_STORAGE_KEY);
    return savedFilters
      ? JSON.parse(savedFilters)
      : {
        selectDate: 'date',
        time: '',
        week: '',
        date: getCurrentcompleteDate(),
        month: '',
        shift: '',
        starting: '',
        ending: ''
      };
  };
  const [detections, setDetections] = useState([]);
  // const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(12);
  const [employeeFilter, setEmployeeFilter] = useState('');
  const [filters, setFilters] = useState(getInitialFilters)
  const [callApi, setCallAPi] = useState(false)
  const [loading, setloading] = useState(true)

  useEffect(() => {

    // setLoading(false);

    // When ready to use the API, uncomment this:
    getlivealertsdata();
  }, []);

  const getlivealertsdata = async () => {
    try {
      setloading(true);
      const userData = JSON.parse(localStorage.getItem('userData'));

      const payload = {
        client_id: userData?.client?.id,
        factory_id: userData?.factory?.id,
        limit: 100, // Get more data to handle pagination client-side
        camera_id: "",
        employee_id: "",
        filters: {
          date: filters?.date,
          week: filters?.week,
          month: filters?.month,
          starting: '',
          ending: '',
        },
      };

      const res = await Entrycameramonitor.getLiveAlerts(payload);
      console.log('ressss', res?.data?.data)
      if (res.status === 200) {
        setDetections(res?.data?.data || []);
      }
    } catch (error) {
      console.error("Error fetching face detections:", error);
    } finally {
      setloading(false);
    }
  };

  const handleSave = () => {
    const updatedFilters = {
      selectDate: filters.selectDate,
      time: '',
      week: '',
      date: '',
      month: '',
      shift: filters.shift,
      starting: '',
      ending: '',
    };

    switch (filters.selectDate) {
      case 'date':
        if (!filters.date) {
          errorToast('Please select a Date!');
          return;
        }
        updatedFilters.date = filters.date;
        break;
      case 'week':
        if (!filters.week) {
          errorToast('Please select a Week!');
          return;
        }
        updatedFilters.week = filters.week;
        break;
      case 'month':
        if (!filters.month) {
          errorToast('Please select a Month!');
          return;
        }
        updatedFilters.month = filters.month;
        break;
      case 'custom':
        if (!filters.starting || !filters.ending) {
          errorToast('Please select both Startin and Ending Dates!');
          return;
        }
        updatedFilters.starting = filters.starting;
        updatedFilters.ending = filters.ending;
        break;
      default:
        break;
    }
    getlivealertsdata()
    setFilters(updatedFilters);
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(updatedFilters));
    // setCallAPi((prev) => !prev);
  }
  const handleCancel = () => {
    const updatedFilters = {
      selectDate: 'date',
      time: '',
      week: '',
      date: getCurrentcompleteDate(),
      month: '',
      shift: '',
      starting: '',
      ending: ''
    };
    getlivealertsdata()
    setFilters(updatedFilters)
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(updatedFilters));
    // setCallAPi(!callApi)
  }

  // Filter detections by camera position
  const gateInDetections = detections.filter(
    detection => detection.camera_position_no === "Gate In"
  );

  const gateOutDetections = detections.filter(
    detection => detection.camera_position_no === "Gate Out"
  );

  // Filter detections by camera position and other filters
  const filterDetections = (detectionsList) => {
    return detectionsList.filter(detection => {
      const matchesEmployee = !employeeFilter ||
        detection.employee_name.toLowerCase().includes(employeeFilter.toLowerCase()) ||
        detection.employee_id.toLowerCase().includes(employeeFilter.toLowerCase());

      // If time filter is set, check if detection hour matches
      let matchesTime = true;
      if (filters.time) {
        // Extract hour from filter time (format "HH:MM")
        const filterHour = filters.time.split(':')[0];

        // Extract hour from detection datetime
        const detectionTime = new Date(detection.detection_datetime);
        const detectionHour = String(detectionTime.getHours()).padStart(2, '0');

        // Compare hours only
        matchesTime = detectionHour === filterHour;
      }

      return matchesEmployee && matchesTime;
    });
  };
  console.log('filterss', filters);


  const filteredGateInDetections = filterDetections(gateInDetections);
  const filteredGateOutDetections = filterDetections(gateOutDetections);

  // Pagination logic
  const indexOfLastInItem = currentPage * itemsPerPage;
  const indexOfFirstInItem = indexOfLastInItem - itemsPerPage;
  const currentGateInItems = filteredGateInDetections.slice(indexOfFirstInItem, indexOfLastInItem);
  const currentGateOutItems = filteredGateOutDetections.slice(indexOfFirstInItem, indexOfLastInItem);

  const totalPages = Math.ceil(
    Math.max(filteredGateInDetections.length, filteredGateOutDetections.length) / itemsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };


  //zoom image start
  const [showModal, setShowModal] = useState(false);
  const [imageUrl, setImageurl] = useState();
  const handleImageClick = (photo) => {
    console.log('photttt', photo)
    setImageurl(photo);
    setShowModal(!showModal);
  };
  //zoom image End


  return (
    loading ? (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "60vh" }}>
        <Spinner style={{ width: '3rem', height: '3rem', color: '#1e67d6' }} />
      </div>
    ) : (
      <Container fluid className='dashboard-first-page'>
        <Row className="mb-3">
          <Col>
            <h1 style={{ fontSize: "24px", color: "#1e67d6", fontWeight: "600" }}>All Detections</h1>
          </Col>
          <Col xs="12" xl="9" className="d-flex flex-wrap justify-content-end align-items-end">
            <FiltersComponent
              setFilters={setFilters}
              filtersConfig={[
                { key: "selectDate", options: ["date", "week", "month"], placeholder: "date" },
              ]}
              timeFilter={false}
              handleSave={handleSave}
              handleCancel={handleCancel}
              filters={filters}
            />
          </Col>
        </Row>

        <Row>
          {/* Gate In Section */}
          <Col md="6">
            <Card className="mb-4">
              <CardHeader style={{ backgroundColor: '#1e67d6' }} className="text-white">
                <h5 className="mb-0">Entry Detections</h5>
              </CardHeader>
              <div className="p-3">
                {currentGateInItems.length > 0 ? (
                  <Row>
                    {currentGateInItems.map((detection) => (
                      <Col md="6" xxl="4" className="mb-2" key={detection.log_id}>
                        <FaceCard loading={loading} detection={detection} handleImageClick={handleImageClick} />
                      </Col>
                    ))}
                  </Row>
                ) : (
                  <div className="text-center py-5">No Gate In detections found</div>
                )}
              </div>
            </Card>

            {filteredGateInDetections.length > itemsPerPage && (
              <PaginationComponent
                currentPage={currentPage}
                totalPages={Math.ceil(filteredGateInDetections.length / itemsPerPage)}
                onPageChange={handlePageChange}
              />
            )}
          </Col>

          {/* Gate Out Section */}
          <Col md="6">
            <Card className="mb-4">
              <CardHeader style={{ background: '#3a7bd5' }} className="text-white">
                <h5 className="mb-0">Exit Detections</h5>
              </CardHeader>
              <div className="p-3">
                {currentGateOutItems.length > 0 ? (
                  <Row>
                    {currentGateOutItems.map((detection) => (
                      <Col md="6" xxl="4" className="mb-2" key={detection.log_id}>
                        <FaceCard detection={detection} handleImageClick={handleImageClick} />
                      </Col>
                    ))}
                  </Row>
                ) : (
                  <div className="text-center py-5">No Gate Out detections found</div>
                )}
              </div>
            </Card>

            {filteredGateOutDetections.length > itemsPerPage && (
              <PaginationComponent
                currentPage={currentPage}
                totalPages={Math.ceil(filteredGateOutDetections.length / itemsPerPage)}
                onPageChange={handlePageChange}
              />
            )}
          </Col>
        </Row>


        {showModal && (
          <ImageZoomSingleImage
            photo={imageUrl}
            setShowModal={setShowModal}
          />
        )}
      </Container>

    )
  );
};

export default FaceDetections;
